import React, { type JSX } from "react";
import { Radio as RadioAntd } from "antd";
import styled from "styled-components";
import Text from "../Text/Text";

const RadioStyled = styled(RadioAntd)``;
interface Props extends React.ComponentProps<typeof RadioAntd.Group> {
  items: {
    value: string | number;
    label: string;
    key?: string;
  }[];
}
function Radio({ ...props }: Props): JSX.Element {
  return (
    <RadioStyled.Group {...props}>
      {props.items.map((item, idx) => (
        <RadioAntd key={item.key || idx} value={item.value}>
          <Text fontSize={14} fontWeight={400} fontFamily='Sarabun'>
            {item.label}
          </Text>
        </RadioAntd>
      ))}
    </RadioStyled.Group>
  );
}

export default Radio;
